<template>
  <div class="bg-white shadow-lg p-3 w-[300px] h-[300px] flex flex-col text-center justify-center text-sm font-bold items-center p-5">
    <img :src="'/img/home/qr.webp'" alt="" class="h-3/4" />
    <p class="hidden md:block">
      Escanea si estas en la versión de escritorio y ¡agréganos a tus
      contactos!.
    </p>
  </div>
</template>

<script>
  export default {
    setup() {
      return {};
    },
  };
</script>

<style lang="scss" scoped></style>
